require('./newsletter');
require('./cookies');
require('./contact');
require('./header');
require('./slider');
require('./search');
require('./visitors');
require('./bubbles');
require('./christmas');
require('./darkmode');
require('./story');
require('./stories');
require('./video-overlay');



// WEBPACK FOOTER //
// ./resources/assets/js/modules/index.js